(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('instance-management', {
            parent: 'admin',
            url: '/instance-management',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Instances'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/instances/instances.html',
                    controller: 'InstancesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'created,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }
        }).state('instance-management.action', {
            url: '/{instanceId}/{action}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/instances/instance-management-action-dialog.html',
                    controller: 'InstanceManagementActionController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {
                            instance : $stateParams.instanceId,
                            action: $stateParams.action
                        }
                    }
                }).result.then(function() {
                    $state.go('instance-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
